<template>
  <div class="searchHead484848" :class="{ 'admin-search-panel': useStandardLayout }">
	  <slot name="left"></slot>
    <div class="searchForm">
      <el-form
        ref="searchForm"
        v-admin-search="{ enabled: useStandardLayout, fold: collapsible, collapsed: !searchExpanded, onOverflow: updateSearchOverflow, rangeControlWidth }"
        v-model="searchData"
        class="searchComponentsForm"
        :class="{ 'admin-search-form': useStandardLayout }"
      >
		<el-form-item v-if="!useStandardLayout || $slots.prebtns || $scopedSlots.prebtns">
		  <slot name="prebtns"></slot>
		</el-form-item>
		<slot name="searchLeft"></slot>
        <el-form-item
          :label="item.label"
          v-for="(item, index) in list.filter((item) => {
            return !item.hide;
          })"
          :key="index"
        >
          <el-input
			size="small"
            v-if="item.type === 'input'"
            :style="item.style || { width: '180px' }"
            v-model="searchData[item.Field]"
            :placeholder="item.placeholder || `请输入${item.label}`"
          ></el-input>

          <el-cascader
			size="small"
            v-if="item.type === 'city'"
            :style="item.style || { width: '120px' }"
            v-model="diqu"
            :options="diquOptions"
            :props="{
              expandTrigger: 'hover',
              label: 'area_name',
              value: 'area_name',
              children: '_child'
            }"
            @change="handleDiqu"
          >
          </el-cascader>

          <el-cascader
			size="small"
            v-if="item.type === 'cascader'"
            :style="item.style || { width: '120px' }"
            v-model="searchData[item.Field]"
            :options="item.options || []"
            :props="item.props || {}"
            clearable
          >
          </el-cascader>

          <el-select
            v-if="item.type === 'select'"
            class="base-search-single-select"
            :style="item.style || { width: '120px' }"
            v-model="searchData[item.Field]"
			size="small"
            :filterable="!!item.filterable"
            :clearable="!!item.clearable"
            :placeholder="item.placeholder || `请选择${item.label}`"
          >
            <el-option
              v-for="item1 in item.options"
              :key="item1[item.key] || item1.value"
              :label="item1[item.name] || item1.label"
              :value="item1[item.key] || item1.value"
            >
            </el-option>
          </el-select>
		  <el-select
		    v-if="item.type === 'selectmultiple'" multiple
		    class="base-search-multiple-select"
		    :style="item.style || { 'min-width': '200px' }"
		    v-model="searchData[item.Field]"
		  			size="small"
		    :filterable="!!item.filterable"
		    :collapse-tags="!!item.collapseTags"
		    :placeholder="item.placeholder || `请选择${item.label}`"
		  >
		    <el-option
		      v-for="item1 in item.options"
		      :key="item1[item.key] || item1.value"
		      :label="item1[item.name] || item1.label"
		      :value="item1[item.key] || item1.value"
		    >
		    </el-option>
		  </el-select>
			
			<el-date-picker
				v-if="item.type === 'datePic'"
				  :style="item.style || { width: '320px' }"
				  v-model="searchData[item.Field]"
			      type="date"
				  format="yyyy-MM-dd"
				  value-format="yyyy-MM-dd"
			      :placeholder="item.placeholder || `请选择${item.label}`">
			    </el-date-picker>
				
          <el-date-picker
			size="small"
            v-if="item.type === 'datePicker'"
            :data-admin-search-range-format="item.format || 'yyyy-MM-dd HH:mm:ss'"
            :style="item.style || { width: '320px' }"
            v-model="searchData[item.Field]"
            :type="item.pickerType || 'datetimerange'"
            range-separator="至"
            :format="item.format || 'yyyy-MM-dd HH:mm:ss'"
            :value-format="item.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
            :start-placeholder="item.startPlacholder?item.startPlacholder:'开始时间'"
            :end-placeholder="item.endPlacholder?item.endPlacholder:'结束时间'"
          >
          </el-date-picker>
		  
		  <el-date-picker
		        size="small"
				v-if="item.type === 'datetime'"
				:style="item.style || { width: '320px' }"
				v-model="searchData[item.Field]"
		        type="datetime"
		        :placeholder="item.placeholder || `请选择${item.label}`">
		      </el-date-picker>
		  
		  <xsk-cascader ref="cityRef" v-if="item.type === 'addressPC'"  :areaShow="item.areaShow?true:false" :style="item.style || { width: '280px' }"
            v-model="addressPCArr" :city="addressPCArr" @confirm="(e)=>confirmAddress(e,item.Field)"></xsk-cascader>
			
			<xks-cascader ref="cityRef" v-if="item.type === 'addressPCRadio'" :areaShow="false"
			  :style="item.style || { width: '280px' }" v-model="addressPCArr" :city="addressPCArr"
			  @confirm="(e) => confirmAddress(e, item.Field)"></xks-cascader>
        </el-form-item>
		<slot name="item"></slot>
        <template v-if="legacyLayout">
          <el-form-item v-if="list.length > 0">
            <el-button type="primary" size="small" plain @click="search" class="base_but_style">查询</el-button>
            <el-button type="primary" size="small" plain @click="reset" class="base_but_style">重置</el-button>
            <slot v-if="inlineBtns" name="btns"></slot>
          </el-form-item>
          <el-form-item v-if="!inlineBtns"><slot name="btns"></slot></el-form-item>
        </template>
        <el-form-item v-else-if="list.length > 0 || $slots.btns || $scopedSlots.btns" :class="useStandardLayout ? 'base-search-actions admin-search-item admin-search-actions' : ''">
          <template v-if="list.length > 0">
            <el-button type="primary" size="small" plain @click="search" class="base_but_style">查询</el-button>
            <el-button type="primary" size="small" plain @click="reset" class="base_but_style">重置</el-button>
          </template>
          <slot name="btns"></slot>
          <el-button v-if="useStandardLayout && collapsible && searchOverflow" type="text" size="small" class="admin-search-toggle"
            :aria-expanded="String(searchExpanded)" @click="searchExpanded = !searchExpanded">{{ searchExpanded ? '收起' : '展开' }}<i :class="searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i></el-button>
        </el-form-item>
      </el-form>
    </div>
	
  </div>
</template>

<script>
// import { eltips } from '@/util/util.js';
export default {
  name: 'SearchHead',
  props: {
    // 指定历史订单页显式启用；其他页面保留当前搜索布局。
    legacyLayout: { type: Boolean, default: false },
    standardLayout: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array,
      default: () => []
    },
    searchData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    moduleName: {
      type: String,
      default: ''
    },
    delField: {
      type: Array,
      default: () => {
        return [];
      }
    },
    hideDefBtn: {
      type: Boolean,
      default: false
    },
    inlineBtns: {
      type: Boolean,
      default: false
    },
    collapsible: {
      type: Boolean,
      default: true
    },
    // 可显式指定范围控件最小宽度；默认仅在整排放得下时自动收紧。
    rangeControlWidth: { type: Number, default: 0 },
    //    1:查询 2：重置 3：新增 4：导入 5：导出
    handleBtns: {
      type: Array,
      default: () => {
        return [1, 2, 3];
      }
    },
    // 导出地址
    exportUrl: {
      type: String,
      default: ''
    },
    exportName: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  },
  computed: {
    useStandardLayout() { return this.standardLayout && !this.legacyLayout; }
  },
  data() {
    return {
      searchExpanded: false,
      searchOverflow: false,
		addressPCArr:[],
      diquOptions: [],
      diqu: '',
      datePicker: [],
      margin: false
    };
  },
  created() {
    // this.getDiqu();
  },
  methods: {
    updateSearchOverflow(value) {
      if (this.searchOverflow !== value) this.searchOverflow = value;
    },
	  confirmAddress(e,type){
		  this.searchData[type] = e.toString()
	  	// this.search.post.province = e[0]
	  	// this.search.post.city = e[1]
	  },
    add() {
      this.$emit('add');
    },
    reset() {
      for (const key in this.searchData) {
        this.searchData[key] = '';
      }
	  console.log("请出示")
	  this.addressPCArr = []
	  this.$emit('reset');
      this.search();
    },
    search() {
      this.$emit('search', this.searchData);
    },
    handleDiqu(e) {
      this.searchData.province = e[0];
      this.searchData.city = e[1];
      this.searchData.area = e[2];
    },
    getDiqu() {
      this.axios.get('/api/get_area_tree').then((res) => {
        this.diquOptions = res.data;
        this.diquOptions.forEach((e, i) => {
          if (e._child.length === 0) {
            delete e._child;
          } else {
            e._child.forEach((e1, i1) => {
              if (e1._child.length === 0) {
                delete e1._child;
              } else {
                e1._child.forEach((e2, i1) => {
                  if (e2._child.length === 0) {
                    delete e2._child;
                  } else {
                    e2._child.forEach((e2, i1) => {});
                  }
                });
              }
            });
          }
        });
      });
    },
    exportExcel() {
      let data = {};
      if (this.exportUrl == this.url) {
        data = {
          ...this.searchData,
          page: 'download'
        };
      } else {
        data = {
          ...this.searchData
        };
      }
      console.log(
        '%c [ data ]-158',
        'font-size:13px; background:#32813d; color:#76c581;',
        data
      );

      this.axios
        .get(this.exportUrl, {
          params: data,
          responseType: 'blob'
        })
        .then((res) => {
          if (res.code === 1) {
            this.$util.eltips(res.msg);
          } else {
            const blob = new Blob([res], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            });

            if (window.navigator.msSaveOrOpenBlob) {
              // 兼容ie
              window.navigator.msSaveBlob(blob, this.exportName);
            } else {
              const downloadElement = document.createElement('a');
              const href = window.URL.createObjectURL(blob); //创建下载的链接
              downloadElement.href = href;

              downloadElement.download = this.exportName; // 下载后文件名

              document.body.appendChild(downloadElement);
              // 此写法兼容火狐
              const evt = document.createEvent('MouseEvents');
              evt.initEvent('click', false, false);
              downloadElement.dispatchEvent(evt);

              document.body.removeChild(downloadElement);
            }
          }
        });
    }
  }
};
</script>

<style lang="scss" >
	
.searchHead484848 {
  padding: 10px 20px 20px;
  background: #ffffff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .searchForm {
    .searchComponentsForm {
      display: flex;
      flex-wrap: wrap;

      .defBtn {
        display: flex;
      }

      .el-form-item {
        margin: 10px 10px 10px 0;
        display: flex;

        &:last-child {
          margin-right: 0;
        }

        .el-form-item__label,
        .el-form-item__label-wrap {
          flex-shrink: 0;
		  line-height: 32px;;
		  height: 32px;
		  border-radius:2px
        }
		.el-input__inner{
			line-height: 32px;
			height: 32px;
			border-radius:2px
		}
        .el-radio {
          margin-right: 15px;
        }
		
        .el-form-item__content {
          margin-left: 0 !important;
          flex: 1;

          .el-cascader,
          .el-select,
          .el-input,
          .el-date-editor {
            width: 100%;
          }

          .el-range-separator {
            width: 12px;
          }
        }
      }
    }

    .el-form-item {
      margin-bottom: 0px !important;

      .el-cascader {
        line-height: normal;
      }
    }
  }
}
.base_but_style{
	height: 32px !important;
	border-radius: 2px;
	padding:9px  30px;
}
.searchHead484848 .base-search-single-select {
	height: 32px;
	box-sizing: border-box;
}
.searchHead484848 .base-search-single-select .el-input,
.searchHead484848 .base-search-single-select .el-input__inner {
	height: 32px !important;
	min-height: 32px !important;
	line-height: 32px !important;
}
 .el-input__icon{
 	line-height: 32px !important;
 }
  .el-date-editor .el-range__icon{
	  line-height: 25px !important;
  }
</style>
